import { useMemo } from "react";
import {
  CATEGORY_METADATA,
  getCategoryForRule,
} from "../../../../components/campaign/rulesAndOutcomes/rules/ruleCategories";
import ViewComponentsRenderer from "../../../../components/campaign/viewComponents/ViewComponentsRenderer";
import { FeatureToggle, useFeatureToggle } from "../../../../utils/featureToggle";
import SummaryCard from "./SummaryCard";
import "./campaignRulesSummary.scss";

export default function CampaignRulesSummary({
  campaignRules = [],
  isViewScreen,
  handleOutcomesEditSection,
}) {
  const showNewDesign = useFeatureToggle(
    FeatureToggle.showNewDesignOfRulesCategories
  );

  // Group rules by category
  const groupedRules = useMemo(() => {
    if (!showNewDesign) return null;

    const groups = {};

    campaignRules.forEach((rule, index) => {
      const category = getCategoryForRule(rule.ruleDefinition);
      if (!category) return;

      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push({ rule, index });
    });

    return groups;
  }, [campaignRules, showNewDesign]);

  // Helper to render a single rule
  const renderRule = (rule, i) => (
    <ViewComponentsRenderer
      data={rule.ruleData}
      inputSchema={rule.ruleDefinition?.inputSchema}
      customComponentName={rule.ruleDefinition?.slug}
      uiSchema={rule.ruleDefinition?.uiSchema || {}}
      key={rule.ruleDefinition?.slug + i + JSON.stringify(rule.ruleData)}
      ruleDefinition={rule.ruleDefinition}
    />
  );

  return (
    <SummaryCard
      title="Campaign Setup - Rules"
      isViewScreen={isViewScreen}
      handleEditSection={handleOutcomesEditSection}
    >
      {showNewDesign && groupedRules
        ? // New Design: Show rules grouped by category
          Object.keys(groupedRules).map((categoryId) => {
            const categoryMeta = CATEGORY_METADATA.find(
              (cat) => cat.id === categoryId
            );
            const categoryName = categoryMeta?.name || categoryId;
            const rulesInCategory = groupedRules[categoryId];
            const isWinningLimit = categoryId === "user-winning-limit";

            return (
              <div
                key={categoryId}
                className="campaign-rules-summary-category-group"
              >
                <h4 className="category-title">
                  {isWinningLimit ? "User Winning Limit in Campaign:" : categoryName}
                </h4>
                {rulesInCategory.map(({ rule, index }) => renderRule(rule, index))}
              </div>
            );
          })
        : // Old Design: Show flat list of rules
          campaignRules?.map((rule, i) => renderRule(rule, i))}
    </SummaryCard>
  );
}
